import { Injectable, inject } from '@angular/core';
import { DalState, EffectFeedbackActions, EffectFeedbackInterface, EffectFeedbackQueries } from '@campus/dal';
import { Action, Store, select } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { FEEDBACK_SERVICE_TOKEN, FeedBackServiceInterface } from '../../services';

@Injectable({ providedIn: 'root' })
export class ErrorDialogViewModel {
  public errorFeedback$: Observable<EffectFeedbackInterface>;

  private store: Store<DalState> = inject<Store<DalState>>(Store);
  private feedbackService: FeedBackServiceInterface = inject<FeedBackServiceInterface>(FEEDBACK_SERVICE_TOKEN);

  constructor() {
    this.initialize();
  }

  public onFeedbackDismissed(event: { feedbackId: string; action: Action }): void {
    this.store.dispatch(
      new EffectFeedbackActions.DeleteEffectFeedback({
        id: event.feedbackId,
        userAction: event.action,
      })
    );

    // Retry previous failed action
    if (event.action) this.store.dispatch(event.action);
  }

  private initialize() {
    this.initializeStreams();
  }

  private initializeStreams() {
    this.errorFeedback$ = this.getErrorFeedback$();
  }

  private getErrorFeedback$(): Observable<EffectFeedbackInterface> {
    return this.store.pipe(
      select(EffectFeedbackQueries.getNextError),
      map(this.feedbackService.addDefaultCancelButton)
    );
  }
}
